"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScpSearchClientContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var SearchClientContext_1 = require("icf-search-client-ui/lib/react/SearchClientContext");
var TrackingEvents_1 = require("./TrackingEvents");
var ScpSearchClientContext = function (props) {
    var eventPublisher = props.tracking && props.tracking.eventPublisher
        ? {
            // TODO: Find a way to obscure/hide event names without having to put random numbers all over the place.
            // Probably by using a mapping to a branded type instead of a name to id mapping, so then it's known statically.
            send: function (eventId, context, key, includeUserId) {
                if (key === void 0) { key = undefined; }
                if (includeUserId === void 0) { includeUserId = false; }
                return props.tracking.eventPublisher.send(TrackingEvents_1.eventIdMapping.get(eventId), context, key, includeUserId);
            },
        }
        : undefined;
    var customProps = __assign(__assign({}, props), { tracking: __assign(__assign({}, props.tracking), { eventPublisher: eventPublisher }) });
    return (0, jsx_runtime_1.jsx)(SearchClientContext_1.SearchClientContext, __assign({}, customProps, { children: props.children }));
};
exports.ScpSearchClientContext = ScpSearchClientContext;
exports.ScpSearchClientContext.displayName = "ScpSearchClientContext";
//# sourceMappingURL=ScpSearchClientContext.js.map